import React from 'react';
import PropTypes from 'prop-types';
import Button from 'base-ui/dist/Button';
import Icon from 'base-ui/dist/Icon';
import { GoogleLogin as GLogin } from 'react-auth';
import getConfig from 'next/config';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

/**
 * GoogleLogin.js
 *
 * Render a button to connect to google provider using react-auth.
 */
const GoogleLogin = ({ action, label }) => (
  <GLogin
    clientId={publicRuntimeConfig.GOOGLE_CLIENT_ID || publicRuntimeConfig.google_client_id}
    responseType="code"
    onCode={action}
    redirectUri={window.location.origin}
  >
    <Button
      className="full"
      size="big"
      color="white"
      borderColor="googleplus"
      textColor="googleplus"
      tag="a"
    >
      <Icon name="google" prefix="fab" />
      {' '}
      {label}
    </Button>
  </GLogin>
);

GoogleLogin.propTypes = {
  /**
   * The callback action that perform when we receive authorization code from provider.
   */
  action: PropTypes.func.isRequired,
  /**
   * A simple label to show on button.
   */
  label: PropTypes.string.isRequired,
};

export default GoogleLogin;
